import { getBaseRole } from 'auth/helper';
import { BaseRoleCodes } from '../theme/constants';

export function getStatus(selectedRole) {
  const role = getBaseRole(selectedRole);
  switch (role) {
    case BaseRoleCodes.RELEASE_PARTY_CODE:
      return 'active';
    case BaseRoleCodes.TERMINAL_CODE:
      return 'terminal';
    case BaseRoleCodes.SHIP_AGENT_CODE:
      return 'shipping';
    case BaseRoleCodes.TRANSPORT_OPERATOR_CODE:
      return 'active';
    default:
      throw Error('unknown user profile');
  }
}

export function getRoleName(selectedRole) {
  return selectedRole.replaceAll('CPU', '').replaceAll(' ', '').replaceAll('_', '');
}
